export default "/images/infant_feeding_policy_sm.jpg?a9115c7b8b71dc2be46a6ef359d79393";